import { sanitizeInput } from '@shared/utils/sanitize-input/sanitizeInput';
import { z } from 'zod';

const sanitize = (v: unknown): string =>
  sanitizeInput(typeof v === 'string' ? v : undefined) ?? '';

export const BIRTHDATE_FORMAT_ERROR =
  'Invalid date. Please use the format DD-MM-YYYY.';

export const editIdentitySchema = z.object({
  salutation: z.preprocess(sanitize, z.string()),
  givenName: z.preprocess(
    sanitize,
    z
      .string()
      .trim()
      .min(1, 'Cannot be left blank')
      .max(40, 'Cannot exceed 40 characters')
  ),
  middleName: z.preprocess(
    sanitize,
    z.string().trim().max(40, 'Cannot exceed 40 characters')
  ),
  lastName: z.preprocess(
    sanitize,
    z
      .string()
      .trim()
      .min(1, 'Cannot be left blank')
      .max(80, 'Cannot exceed 80 characters')
  ),
  birthdate: z
    .date()
    .refine(d => /^[1-9]\d{3}$/.test(String(d.getFullYear())), {
      message: BIRTHDATE_FORMAT_ERROR,
    })
    .nullable(),
});

export type EditIdentityFormData = z.infer<typeof editIdentitySchema>;
